




















































import { computed, defineComponent, SetupContext } from '@vue/composition-api'
import { PageBanner } from '@/types'
import { RoutePath } from '@/router'
import { getAreaInfo } from '@/store/modules/area.store'

export default defineComponent({
  props: {
    backgroundImage: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    paragraph: String,
    light: {
      type: Boolean,
      default: false
    },
    showAddress: {
      type: Boolean,
      default: false
    }
  },
  setup (props: PageBanner, context: SetupContext) {
    const store = context.root.$store

    const address = computed(() => {
      const areaInfo = getAreaInfo(store)

      if (!areaInfo) {
        return null
      }

      const apartmentNumber = areaInfo.ApartmentNumber

      return `${areaInfo.FullAddress}${apartmentNumber ? `-${apartmentNumber}` : '' }, ${areaInfo.ZipPostalCode} ${areaInfo.City}`
    })

    const bannerStyle = computed(() => {
      return {
        '--bg-image-url': props.backgroundImage ? `url("${props.backgroundImage}")` : ''
      }
    })

    const gotoWhereDoYouLivePage = () => {
      context.root.$router.push(RoutePath.WhereDoYouLivePage)
    }

    return {
      bannerStyle,
      address,
      gotoWhereDoYouLivePage
    }
  }
})
